<template>
      <!-- 支持与帮助弹窗 -->
  <Transition>
    <div class="pop-bg pass" v-show="props.isToastShow">
      <div class="pop-box">
        <p>{{ $t("账户解锁申请") }}</p>
        <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="emit('closeToast')">

        <div class="amend binding-tel">
          <div class="select-wrap">
            <p class="name">
              {{ $t('封锁原因') }}
            </p>
            <div>{{ $t('账户五次预约会议而没有使用,账户信用等级降为0') }}；</div>
          </div>
          <br>
          <common-select :name="$t('申请承诺')" v-model="state.unlockCode" :options="state.unlockList"></common-select>

          <div class="select-wrap">
            <p class="name">
              {{ $t('附加说明') }}
            </p>
            <el-input type="textarea" show-word-limit rows="4" maxlength="777"
                      v-model="state.description" :placeholder="$t('请输入说明,可不填')"/>
          </div>
          <br>
          <div class="next" @click="submit()">{{ $t("提交") }}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import {
  useStore
} from 'vuex';
import {
  onMounted,
  getCurrentInstance, reactive
} from "vue";
import {accountUnlockEnum} from "@/utils/constants";
import {ElMessage} from "element-plus";
import {createAccountUnlock} from "@/api/yuzhen/accountUnlock";
// 多语言调用
const {appContext: {config: {globalProperties}}} = getCurrentInstance();

const store = useStore();

const props = defineProps(["isToastShow", "data"])
const emit = defineEmits([]);
const state = reactive({
  unlockCode: 0,
  description: '',
  unlockList: [{
    id: "0",
    txt: "请选择",
  },
    ...accountUnlockEnum
  ],
})


function submit(){
  if(state.unlockCode == 0){
    ElMessage({
      type: 'error',
      message: globalProperties.$t("请选择申请承诺"),
    })
    return
  }
  let data = {}
  state.unlockList.forEach(item => {
    if(item.id == state.unlockCode){
      data.type = item.txt
    }
  })
  data.description = state.description
  createAccountUnlock(data).then(res => {
    ElMessage({
      type: 'success',
      message: globalProperties.$t("您的申请已成功提交，24小时内会批复您的申请！"),
      duration: 5000,
    })
    emit('closeToast')

  }).catch(err => {})




}


onMounted(() => {

})



</script>

<style src="./accountUnlock.css" scoped>
</style>
